//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';


export default {
    state: {
        yardExportList: [],
        searchRequest: null,
      },

      mutations: {
        updateYardExportList(state, list) {
          state.yardExportList = list;
        },
        updateSearchYardExportListRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async loadYardExportList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
    
        
          // if (requestToSend.chzStartDate.endDate) {
          //   requestToSend.chzStartDate.endDate = moment(requestToSend.chzStartDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.chzStartDate.startDate && !requestToSend.chzStartDate.endDate) {
          //   requestToSend.chzStartDate.endDate = moment(requestToSend.chzStartDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          // if (requestToSend.apptDate.endDate) {
          //   requestToSend.apptDate.endDate = moment(requestToSend.apptDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.apptDate.startDate && !requestToSend.apptDate.endDate) {
          //   requestToSend.apptDate.endDate = moment(requestToSend.apptDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }

          // if (requestToSend.pickupDate.endDate) {
          //   requestToSend.pickupDate.endDate = moment(requestToSend.pickupDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.pickupDate.startDate && !requestToSend.pickupDate.endDate) {
          //   requestToSend.pickupDate.endDate = moment(requestToSend.pickupDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }

          if (requestToSend.apptDate) {
             if (requestToSend.apptDate.startDate)
             {
                requestToSend.apptDate.startDate = dateFormat.getLocalDate(requestToSend.apptDate.startDate);
             }
          
             if (requestToSend.apptDate.endDate)
             {
                requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.endDate);
             }
             else
             {
                requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.startDate);
             }
          }

          // if (requestToSend.cargoCutOff.startDate)
          // {
          //   requestToSend.cargoCutOff.startDate = dateFormat.getLocalDate(requestToSend.cargoCutOff.startDate);
          // }

          // if (requestToSend.cargoCutOff.endDate)
          // {
          //   requestToSend.cargoCutOff.endDate = dateFormat.getLocalDateEnd(requestToSend.cargoCutOff.endDate);
          // }
          // else
          // {
          //   requestToSend.cargoCutOff.endDate = dateFormat.getLocalDateEnd(requestToSend.cargoCutOff.startDate);
          // }


          // if (requestToSend.pickupDate.startDate)
          // {
          //   requestToSend.pickupDate.startDate = dateFormat.getLocalDate(requestToSend.pickupDate.startDate);
          // }

          // if (requestToSend.pickupDate.endDate)
          // {
          //   requestToSend.pickupDate.endDate = dateFormat.getLocalDateEnd(requestToSend.pickupDate.endDate);
          // }
          // else
          // {
          //   requestToSend.pickupDate.endDate = dateFormat.getLocalDateEnd(requestToSend.pickupDate.startDate);
          // }


          // if (requestToSend.chzStartDate.startDate)
          // {
          //   requestToSend.chzStartDate.startDate = dateFormat.getLocalDate(requestToSend.chzStartDate.startDate);
          // }

          // if (requestToSend.chzStartDate.endDate)
          // {
          //   requestToSend.chzStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzStartDate.endDate);
          // }
          // else
          // {
          //   requestToSend.chzStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.chzStartDate.startDate);
          // }



          

            const st = performance.now();
            //const result = await api.post('/api/w/gst/yardexportlist', requestToSend);
            const result = await newAPIPost('/api/w/gst/yardexportlist', requestToSend);
            commit('updateSearchYardExportListRequest', fallbackRequest);
            console.log(requestToSend);
            console.log(result);
            return commit('updateYardExportList', result);
            
                },
      },

      getters: {
        getYardExportList: state => state.yardExportList,
      },




}
